import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Autentificare reușită");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Email sau parolă incorectă");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center py-16" data-testid="admin-login-page">
      <div className="container-vdz max-w-md">
        <div className="text-center mb-10">
          <div className="eyebrow mb-3">Admin</div>
          <h1 className="font-serif-display text-4xl" style={{ color: "var(--vdz-navy)" }}>Vis de Zi · Panou</h1>
        </div>
        <form onSubmit={submit} className="p-8 border space-y-4" style={{ borderColor: "var(--vdz-cream-border)", background: "white" }}>
          <input className="vdz-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          <input className="vdz-input" type="password" placeholder="Parolă" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          <button type="submit" className="btn-gold w-full" disabled={loading} data-testid="admin-login-submit-button">
            {loading ? "Se autentifică..." : "Autentificare"}
          </button>
        </form>
      </div>
    </div>
  );
}
